import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import negotiators from '../services/negotiators'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    logged: true,
    keycloak: {},
    current_warrant: null,
    route: [],
    jobs: [],
    account_statements: [],
    url: process.env.VUE_APP_API_URL || "https://test.test/api"
  },
  getters: {
    job: (state) => id => {
      return state.jobs.find(job => job.ID == id) || null;
    },
    jobs(state) {
      return state.jobs;
    },
    current_warrant(state) {
      return state.current_warrant;
    },
    account_statements(state) {
      return state.account_statements
    },
    url(state) {
      return state.url
    },
    negoID(state) {
      return state.keycloak.me.ID;
    },
    getRoute(state) {
      return state.route;
    },
    isLogged(state) {
      return state.logged
    },
    isSuperAdmin(state) {
      return state.keycloak.tokenParsed.resource_access.RecuperatorVuejs.roles.includes('super_admin')
    },
    isAdmin(state) {
      return state.keycloak.tokenParsed.resource_access.RecuperatorVuejs.roles.includes('administrator')
    },
    isClient(state) {
      return state.keycloak.tokenParsed.resource_access.RecuperatorVuejs.roles.includes('client')
    },
    isNegotiator(state) {
      return  state.keycloak.tokenParsed.resource_access.RecuperatorVuejs.roles.includes('nego')
    },
    userProfile(state) {
      return  state.keycloak.tokenParsed
    },
    getKeycloak(state) {
      return  state.keycloak
    }
  },
  mutations: {
    set_jobs(state, payload) {
      state.jobs = payload;
    },
    set_current_warrant(state, payload) {
      state.current_warrant = payload;
    },
    updateAccountStatements(state, payload) {
      state.account_statements = payload;
    },
    deleteRoute(state) {
      state.route = [];
    },

    toggleRoute(state, payload) {
      if(state.route.includes(payload)) {
        state.route = state.route.filter(x => x !== payload);
      } else if(state.route.length < 25) {
        state.route.push(payload);
      }
    },
    loadUser(state, payload) {
      state.keycloak = payload;
    },
    updateUser(state, payload) {
      
      state.keycloak.me = payload.me
    },
    
  },
  actions: {
    loadCurrentUser(context, obj) {
      return new Promise((resolve, reject) => {
        negotiators.get(obj.idTokenParsed.sub).then(response => {
          if (!response.data.error) {
            context.commit('updateUser', { keycloak: obj, me: response.data });
            resolve();
          }
          else {
            reject(response.data.message)
          }
        }, () => {
          reject();
        });
      });
    },
    logout(context) {
      context.state.keycloak.logout();
    },
    history(context, payload) {
      return new Promise((resolve, reject) => {
        negotiators.history(payload).then(() => {
          resolve();
        }, () => {
          reject();
        })
      })
      
    },
    search(context, { data }) {
      if(data.command == 'search') {
        switch(data.product) {
          case 'creditor':
            router.push({'name': 'creditorsSearch', params: { 'search' : data.originalQuery}});
            break;
          case 'debtor':
            router.push({'name': 'debtorsSearch', params: { 'search' : data.originalQuery}});
            break;
          case 'payment':
            router.push({'name': 'paymentsSearch', params: { 'search' : data.originalQuery}});
            break;
          case 'invoice':
            router.push({'name': 'invoicesSearch', params: { 'search' : data.originalQuery}});
            break;
        }
      }
    }
  }
})